import { Alert, Box, Button, Typography } from '@mui/material';
import { common } from '@mui/material/colors';
import Logo from 'common/components/logo';
import React from 'react';
import { createStyleSheet, handleError } from 'utils/helpers';
import iconSuccess from 'assets/images/icons/icon-success.svg';
import { useTranslation } from 'react-i18next';
import { colors } from 'common/constants';
import {
    emailSubscription,
    getStatusEmailSubscription,
} from 'services/user.service';
import { toast } from 'react-toastify';

const EmailSubscription: React.FC = () => {
    const [emailStatus, setEmailStatus] = React.useState<boolean>();
    const [emailStatusText, setEmailStatusText] = React.useState<string>();
    const [enable, setEnable] = React.useState<boolean>(false);
    React.useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getStatusEmailSubscription();
                if (response.success) {
                    setEnable(true);
                    setEmailStatus(response.data.mail_subscription);
                } else {
                    setEnable(false);
                    toast.error(response.message);
                }
            } catch (error) {
                setEnable(false);
                handleError(error);
            }
        };
        fetchData();
    }, []);
    const handleEmailSubscription = async () => {
        try {
            const response = await emailSubscription();
            if (response.success) {
                setEmailStatus(response.data.mail_subscription);
                setEmailStatusText(response.message);
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            handleError(error);
        }
    };
    const { t } = useTranslation();
    return (
        <Box sx={styles.layout}>
            <Box sx={styles.content}>
                <Box sx={{ marginTop: '83px', marginBottom: '175px' }}>
                    <Alert
                        icon={false}
                        sx={{
                            visibility: `${emailStatusText ? 'visible' : 'hidden'}`,
                            backgroundColor: '#DDFFEB',
                            color: '#13B75B',
                            fontWeight: '600',
                            fontSize: '16px',
                            '.MuiAlert-message': {
                                width: '100%',
                                justifyContent: 'center',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                            },
                        }}
                        severity="success"
                    >
                        <img src={iconSuccess} alt="icon" />
                        {emailStatusText}
                    </Alert>
                </Box>

                <Logo width={127} height={92}></Logo>
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: '700',
                        fontSize: '24px',
                        lineHeight: '30px',
                        marginTop: '46px',
                        marginBottom: '20px',
                        color: common.black,
                    }}
                >
                    {emailStatus
                        ? t('confirm.unsubscribe.email')
                        : 'Đăng ký nhận tin tức qua Email từ SurveyTrue'}
                </Typography>
                {enable && (
                    <>
                        <Typography
                            component={'p'}
                            sx={{
                                fontWeight: '400',
                                fontSize: '14px',
                                lineHeight: '17px',
                                marginBottom: '30px',
                                color: common.black,
                            }}
                        >
                            {emailStatus ? (
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: t('when.you.unsubscribe.email'),
                                    }}
                                />
                            ) : (
                                <div>
                                    Khi bạn ấn nút <b>Đăng ký</b> bên dưới, bạn
                                    sẽ nhận những email marketing từ SurveyTrue.
                                </div>
                            )}
                        </Typography>
                        <Button
                            variant="contained"
                            color="primary"
                            sx={styles.button}
                            onClick={handleEmailSubscription}
                        >
                            {emailStatus ? 'Hủy đăng ký' : 'Đăng kí'}
                        </Button>
                    </>
                )}
            </Box>
        </Box>
    );
};

const styles = createStyleSheet({
    layout: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'start',
        height: '100vh',
        backgroundColor: colors.backgroundColor,
    },
    content: {
        width: '636px',
    },
    button: {
        width: '230px',
        borderRadius: '40px',
        background: colors.main,
        fontSize: '20px',
        fontWeight: '700',
        textTransform: 'none',
    },
});
export default EmailSubscription;
